import client from '../httpClient';

const librarySearchApi = (params) => {
  return client.post('/libraries/search', params, { isShowLoading: false });
};

export default librarySearchApi;
